/**
 * État 2FA du jeton courant, partagé entre Auth.ts et Apicall.ts — dans
 * un module séparé pour éviter un import circulaire entre les deux (Auth.ts
 * utilise déjà Apicall ; Apicall a besoin d'invalider ce drapeau quand une
 * réponse signale que la vérification n'est plus valide, voir Apicall.ts).
 */
let verifieCeJeton = false;

export const markTwoFactorVerified = (): void => {
    verifieCeJeton = true;
};

export const clearTwoFactorVerified = (): void => {
    verifieCeJeton = false;
};

export const isTwoFactorVerifiedCached = (): boolean => verifieCeJeton;
